import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { validators } from '@tacitknowledge/validator/lib/validators';
import { useExchangeLogin } from './services/useExchangeLogin';
import './Exchange.scss';

const validateEmail = email => validators.email(email.toLowerCase(), true);

export const ExchangeLogin = ({ setExchangeData }) => {
  const [orderCode, setOrderCode] = useState('');
  const [email, setEmail] = useState('');

  const { error, exchangeLoginRequest, loading } = useExchangeLogin({ setExchangeData });

  const handleSubmit = e => {
    e.preventDefault();
    exchangeLoginRequest({ orderCode, email });
  };

  const inputClass = error ? 'input input-error' : 'input';
  const disabledButton = !validateEmail(email) || !orderCode || loading;

  return (
    <>
      <form onSubmit={handleSubmit} className="form">
        <h3 className="title">START YOUR EXCHANGE</h3>
        <p className="paragraph">
          Enter your order details, select the item(s) you want to return & find a replacement. You’ll get your
          replacement within <FormattedMessage id="exchanges.request.summary.days"/> days of us receiving your exchange item(s).
        </p>
        <div className="form-group">
          <label htmlFor="orderCode">
            Order number
            <input
              type="text"
              id="orderCode"
              value={orderCode}
              onChange={e => setOrderCode(e.target.value)}
              className={inputClass}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="email">
            Email address
            <span className="sublabel">The email address used to place the original order</span>
            <input
              type="email"
              id="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className={inputClass}
            />
          </label>
        </div>
        <button type="submit" className="button" disabled={disabledButton}>
          Continue to exchange
          {loading && <span className="button--animate icon-loop2" />}
        </button>
      </form>
    </>
  );
};
